module.exports = __webpack_public_path__ + "static/media/Ellipse 7.6a0de24e.png";